<template>
  <el-dialog title="编辑小程序名称" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" label-width="120px">
        <el-form-item label="小程序名称">
          <el-input v-model="dialogContent" placeholder="请输入小程序名称"></el-input>
        </el-form-item>
        <el-form-item label="临时素材">
          <p class="title-text">上传组织机构代码证或营业执照临时素材,上传原件或复印件，复印件务必加盖公司公章
            文件格式为jpg、jpeg、bmp、gif或png，文件大小不超过10M，1M以内不压缩，1M以上将压缩至20%大小。</p>
          <el-upload
                  :action="ImgUrl_"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :data="upload_data"
          >
            <el-button size="mini">点击选择临时素材</el-button>
          </el-upload>
          <p v-if="imgpic" class="cate-success">上传成功</p>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="canleBoxFn">取 消</el-button>
      <el-button type="primary" @click="savePrograma">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "addColumnDialog",
    props: ["visible", "dialogContent"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        ImgUrl_: api.upload_media,
        dialogVisible: this.visible,
        imgpic: '',
        upload_data: {token: sessionStorage.getItem("token")}
      };
    },
    methods: {
      savePrograma() {     
        if (!this.dialogContent) {
          this.$message({
            message: '小程序名称不能为空',
            type: 'warning'
          });
          return
        }
        if (!this.imgpic) {
          this.$message({
            message: '请选择组织机构代码证或营业执照–临时素材上传',
            type: 'warning'
          });
          return
        }
        let data_ = {
          nick_name: this.dialogContent, //	整型 	必填 	- 	- 	昵称
          license: this.imgpic, // 	varchar 	非必填 	- 	- 	组织机构代码证或营业执照–临时素材mediaid
        }
        this.axios
            .post(api.company_edit_name, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '操作成功',
                });
                this.$emit('update:visible', false);
                this.$emit('initFn');
              } 
            })
            .catch(response => {
            });
      },
      canleBoxFn() {
        this.dialogVisible = !this.dialogVisible;
        this.dialogContent = '';
        this.imgpic = '';
      },
      handleAvatarSuccess(res, file) {
        if (res.code === 0) {
          this.imgpic = res.media_id;
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
    }
  };
</script>

